import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { message } from 'antd';
import StoreMapping from '../../views/store-mapping/index.jsx';
import ServiceGoods from '../../views/service-goods/index.jsx';
import ReservationSetting from '../../views/reservation-setting/index.jsx';
import ReservationData from '../../views/reservation-data/index.jsx';
import StoreBusinessSetting from '../../views/store-business-setting/index.jsx';
import StaffManage from '../../views/staff-manage/index.jsx';
import RoleManage from '../../views/role-manage/index.jsx';
import AccountManage from '../../views/account-manage/index.jsx';
import StoreInventory from '../../views/store-inventory/index.jsx';
import styled from 'styled-components';
import AccountAPI from '@/api/account';
import utils from '@/utils/auth';

const Wrapper = styled.div`
  margin: 24px 16px 0;
  .layout-content-wrapper {
    padding: 24px;
    height: calc(100vh - 64px - 24px);
    box-sizing: border-box;
    overflow-y: auto;
    background-color: #ffffff;
  }
`;

export default class Main extends Component {

  componentDidUpdate() {
    /**
     * 更新账号权限
     */
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const { accountId } = userInfo;
    accountId && AccountAPI.queryAccountInfoById({ accountId })
        .then(newUserInfo => {
          delete newUserInfo.token;
          localStorage.setItem('userInfo', JSON.stringify(Object.assign({}, userInfo, newUserInfo)));
        });
  }

  render() {
    const { pathNameAndPermissionName, getPermission } = utils;
    let menus = getPermission().map(o => {
      const [menu] = o.split(':');
      return menu;
    });
    const menuName = Array.from(new Set(menus));
    const routerPathList = pathNameAndPermissionName.filter(o => {
      const { value } = o;
      return menuName.includes(value);
    }).map(o => o.path);

    const Routes = [
      {
        path: '/layout/store-mapping',
        component: StoreMapping,
      },
      {
        path: '/layout/service-goods',
        component: ServiceGoods,
      },
      {
        path: '/layout/reservation-setting',
        component: ReservationSetting,
      },
      {
        path: '/layout/reservation-data',
        component: ReservationData,
      },
      {
        path: '/layout/store-business-setting',
        component: StoreBusinessSetting,
      },
      {
        path: '/layout/staff-manage',
        component: StaffManage,
      },
      {
        path: '/layout/role-manage',
        component: RoleManage,
      },
      {
        path: '/layout/account-manage',
        component: AccountManage,
      },
      {
        path: '/layout/store-inventory',
        component: StoreInventory,
      }
    ];

    const newRoutes = Routes.filter(o => {
      const { path } = o;
      return routerPathList.includes(path);
    });

    let defPath = '/login';
    if (newRoutes.length > 0) {
      defPath = newRoutes[0].path;
    } else {
      localStorage.removeItem('userInfo');
      window.location.href = '/#/login';
      message.info('您的账号无任何菜单权限，请联系管理员');
    }

    return (
      <Wrapper>
        <div className="layout-content-wrapper">
          <Switch>
            {
              newRoutes.map(o => <Route key={o.path} exact path={o.path} component={o.component} />)
            }
            {/* <Route exact path="" component={StoreMapping} /> */}
            {/* <Route exact path="/layout/service-goods" component={ServiceGoods} /> */}
            {/* <Route exact path="/layout/reservation-setting" component={ReservationSetting} /> */}
            {/* <Route exact path="/layout/reservation-data" component={ReservationData} /> */}
            {/* <Route exact path="/layout/store-business-setting" component={StoreBusinessSetting} /> */}
            {/* <Route exact path="/layout/staff-manage" component={StaffManage} /> */}
            {/* <Route exact path="/layout/role-manage" component={RoleManage} /> */}
            {/* <Route exact path="/layout/account-manage" component={AccountManage} /> */}
            {/* <Route exact path="/layout/store-inventory" component={StoreInventory} /> */}
            <Redirect to={defPath} />
          </Switch>
        </div>
      </Wrapper>
    );
  }
 }
